import {Component, Inject, Input, OnInit} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {MX_TRANSLATE_SERVICE_TOKEN, MxButtonModel, MxNotificationService, MxTranslateService} from 'mx-core';
import {MatDialogRef} from '@angular/material/dialog';
import {finalize} from 'rxjs/operators';
import {
    MX_FORGOT_PASSWORD_SERVICE_TOKEN,
    MxForgotPasswordService
} from "../../../shared/services/mx-forgot-password.service";

@Component({
    templateUrl: './mx-forgot-password.component.html',
    standalone: false,
    styleUrls: ['./mx-forgot-password.component.scss']
})
export class MxForgotPasswordComponent implements OnInit {
    form: FormGroup = new FormGroup({
        username: new FormControl('', Validators.required),
        email: new FormControl('', [Validators.required, Validators.email]),
    });

    submitButton: MxButtonModel;
    cancelButton: MxButtonModel;
    requestInProcess = false;

    @Input() error: string | null;

    constructor(
        private notificationService: MxNotificationService,
        private dialogRef: MatDialogRef<MxForgotPasswordComponent>,
        @Inject(DOCUMENT) private document: Document,
        @Inject(MX_FORGOT_PASSWORD_SERVICE_TOKEN) protected forgotPasswordService?: MxForgotPasswordService,
        @Inject(MX_TRANSLATE_SERVICE_TOKEN) protected translateService?: MxTranslateService,
        ) {
    }

    ngOnInit(): void {
        this.cancelButton = {
            label: () => this.getLabel('label.cancel'),
            tooltip: () => this.getLabel('label.cancel'),
            className: 'mxs-button--secondary',
            clickHandler: this.close
        };
        this.submitButton = {
            label: () => this.getLabel('label.submit'),
            permission: 'all',
            tooltip: () => this.getLabel('label.submit'),
            className: 'mxs-button--primary',
            clickHandler: this.submit,
            disabled: () => this.form.invalid || this.requestInProcess,
        };
        this.checkWarning();
    }

    submit = () => {
        if (this.requestInProcess) {
            return;
        }
        this.requestInProcess = true;
        this.notificationService.notify(
            this.forgotPasswordService.forgotPassword(this.form.value.username, this.form.value.email),
            'label.login.password.been.sent',
            ''
        ).pipe(
            finalize(() => this.requestInProcess = false)
        ).subscribe(() => {
            this.dialogRef.close();
        });
    };

    close = () => {
        this.dialogRef.close();
    };

    getLabel(label: string) {
        return this.translateService.getTranslatedLabel(label);
    }

    private checkWarning(): void {
        let warning = localStorage.getItem('Warning');
        if (warning) {
            this.notificationService.showFailure(warning);
            localStorage.removeItem('Warning');
        }
    }
}
